import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@mui/material';
import ViewPicture from './ViewPicture';
import ViewLocation from './ViewLocation';
import CardMedia from '@material-ui/core/CardMedia';
import { Map, Marker, TileLayer, Popup } from 'react-leaflet';
import Leaflet from 'leaflet';
import blueMarker from '../../../../assets/images/Marker/blueMarker.png';
import LocationMark from '../../../../assets/images/Marker/Location Mark.F02.2k.png';
import LocationGreen from '../../../../assets/images/Marker/Location Sign Green.F10.2k.png';
import IconDownload from '../../../../assets/images/Marker/Puntu-Icon-Download.png';
import IconLupa from '../../../../assets/images/Marker/Puntu-Icon-Lupa.png';
import CardActionArea from '@mui/material/CardActionArea';
import Usuario from '../../../../assets/images/Marker/Usuario.jpg';

const iconIn = Leaflet.icon({
    // iconUrl: greenMarker,
    iconUrl: LocationGreen,
    iconSize: [60, 60], // Defina o tamanho desejado aqui, por exemplo, 32x32 pixels
    iconAnchor: [15, 41],
    popupAnchor: [0, -41]
});

const iconOut = Leaflet.icon({
    // iconUrl: redMarker,
    iconUrl: LocationMark,
    iconSize: [60, 60], // Defina o tamanho desejado aqui, por exemplo, 32x32 pixels
    iconAnchor: [15, 41],
    popupAnchor: [0, -41], // point from which the popup should open relative to the iconAnchor
});
const iconAllowed = Leaflet.icon({
    iconUrl: blueMarker,
    iconAnchor: [13.5, 41],
    popupAnchor: [0, -41], // point from which the popup should open relative to the iconAnchor
});



const ActionsTimesheet = ({
    openModalActionsTimesheet,
    handleOpenActionsModal,
    handleCloseActionsModal,
    modalPicture,
    handleClosePicture,
    fotoModal,
    handleViewPicture,
    viewLocation,
    handleCloseViewLocation,
    handleViewLocation,
    timesheetRow,
    handleOpenPicture,
    evetnMap
}) => {

    const lat = timesheetRow && timesheetRow.adressLocation && timesheetRow.adressLocation.lat !== undefined ? timesheetRow.adressLocation.lat : null;
    const lng = timesheetRow && timesheetRow.adressLocation && timesheetRow.adressLocation.lng !== undefined ? timesheetRow.adressLocation.lng : null;
    const zoom = timesheetRow && timesheetRow.adressLocation && timesheetRow.adressLocation.lng !== undefined ? 17 : 1;
    const locationAProved = timesheetRow.eventsLocation
    const latNull = '-19.912998'
    const lngNull = '-43.940933'
    const type = timesheetRow && timesheetRow.type == "Saída" ? "Saída" : "Entrada"

    const dateReference = timesheetRow.dtRegister && timesheetRow.dtRegister.slice(8, 10) + '/' + timesheetRow.dtRegister.slice(5, 7) + '/' + timesheetRow.dtRegister.slice(0, 4)
    const horary = timesheetRow.clockIn ? timesheetRow.clockIn : timesheetRow.clockOut ? timesheetRow.clockOut : '00:00'

    const handleDownloadClick = () => {
        try {
            if (fotoModal) {
                fotoModal.setAttribute('download', `${timesheetRow.author}-${dateReference}-${horary}-${timesheetRow.type}.jpeg`);
                document.body.appendChild(fotoModal);
                fotoModal.click();
            }
        } catch (error) {
            return error;
        }
    };


    return (

        <Dialog
            open={openModalActionsTimesheet}
            onClose={handleCloseActionsModal}
            maxWidth="md"
            PaperProps={{
                style: {
                    backgroundColor: 'white',
                    borderRadius: '20px',
                    width: '550px',
                    height: '500px',
                },
            }}
            scroll='paper'
        >
            {
                !modalPicture && !viewLocation ? (
                    <>

                        <Grid container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '2px' }}>
                            <Grid item xs={5}>

                                <Typography variant="h1" style={{ fontSize: '20px', marginTop: '40px', fontWeight: 'bold', color: '#324158' }} >Informações</Typography>
                                <Typography variant="h6" style={{ fontSize: '13px', marginTop: '20px', color: '#324158' }} ><strong>Autor:</strong> {timesheetRow.author}</Typography>
                                <Typography variant="h6" style={{ fontSize: '13px', color: '#324158' }} ><strong>Tipo:</strong> {timesheetRow.type}</Typography>
                                <Typography variant="h6" style={{ fontSize: '13px', color: '#324158' }} ><strong>Data:</strong> {dateReference}</Typography>
                                <Typography variant="h6" style={{ fontSize: '13px', color: '#324158' }} ><strong>Hora:</strong> {horary}</Typography>
                                <Typography variant="h6" style={{ fontSize: '13px', color: '#324158' }} ><strong> {timesheetRow.timezone ? 'Fuso Horário: ' : ''}</strong> {timesheetRow.timezone}</Typography>
                                <Typography variant="h6" style={{ fontSize: '13px', color: '#324158' }} ><strong>Modo:</strong> {timesheetRow.offline ? 'Offline' : 'Online'}</Typography>
                                {/* <Typography variant="h6" style={{ fontSize: '13px', color: '#324158' }} ><strong>Via:</strong> App</Typography> */}
                                <Typography variant="h6" style={{ fontSize: '13px', color: '#324158' }} ><strong>Origem:</strong> {timesheetRow.isWeb ? 'Web' : timesheetRow.isTimeclokManager ? 'Web' : 'App'}</Typography>
                                <Typography variant="h6" style={{ fontSize: '13px', color: '#324158' }} ><strong>{locationAProved ? 'Observação do Ponto: ' : ''}</strong>{locationAProved ? 'Fora do local' : ' '}</Typography>


                            </Grid>
                            <Grid item xs={5}>
                                <div style={{ position: 'relative', height: 190, margin: '0 auto', width: 200, borderRadius: '20px', marginLeft: '30px', marginTop: '10px' }}>
                                    {
                                        lat && lng ?

                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '150px',
                                                    right: '10px',
                                                    width: '30px',
                                                    height: '30px',
                                                    backgroundColor: '#537ccd',
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: 'pointer',
                                                    zIndex: 1,
                                                }}
                                                onClick={handleViewLocation}
                                            >
                                                <img
                                                    src={IconLupa}
                                                    alt="Ícone de Lupa"
                                                    style={{ width: 20, height: 20 }}
                                                />
                                            </div> : null
                                    }
                                    <div
                                        style={{
                                            position: 'relative',
                                            height: '100%',
                                            width: '100%',
                                            borderRadius: '20px',
                                            zIndex: 0, // Este z-index é menor do que o do ícone para garantir que o ícone fique acima
                                        }}
                                    >
                                        <Map
                                            center={[lat ? lat : latNull, lng ? lng : lngNull]}
                                            zoom={zoom}
                                            style={{ height: '100%', width: '100%', borderRadius: '20px' }}
                                            zoomControl={false}
                                        >
                                            <TileLayer
                                                // attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            />
                                            <Marker
                                                position={[lat ? lat : latNull, lng ? lng : lngNull]}
                                                icon={type == "Saída" ? iconOut : iconIn}
                                                popupAnchor={[0, -41]}
                                            ></Marker>
                                        </Map>
                                    </div>
                                </div>

                            </Grid>
                            <Grid item xs={5} style={{ position: 'relative', top: '1px' }}>
                                <Typography variant="h6" style={{ fontSize: '13px', fontWeight: 'bold', color: '#324158' }}> Justificativa: </Typography>
                                <p style={{ fontSize: '11px', marginTop: '1px', color: '#324158' }}>{timesheetRow.justification}</p>
                                <Typography variant="h6" style={{ fontSize: '9px', fontWeight: 'bold', color: '#324158' }}> {timesheetRow.hash256 ? 'Hash: ' : ' '}</Typography>
                                <div style={{ fontSize: '6px', wordWrap: 'break-word', color: '#324158' }}>
                                    {timesheetRow.hash256}
                                </div>
                            </Grid>
                            <Grid item xs={5} style={{ marginTop: fotoModal ? '-30px' : 0 }}>


                                <CardActionArea style={{ marginLeft: '30px' }}>
                                    <CardMedia
                                        component="img"
                                        image={fotoModal ? fotoModal : Usuario}
                                        style={{ maxWidth: 200, maxHeight: 190, borderRadius: '20px' }}
                                    />
                                    {
                                        fotoModal ?

                                            <div
                                                onClick={handleDownloadClick}
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '10px',
                                                    // right: '-5px',
                                                    marginLeft: '160px',
                                                    width: '30px',
                                                    height: '30px',
                                                    backgroundColor: '#537ccd',
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                <img
                                                    src={IconDownload}
                                                    alt="Ícone de Download"
                                                    style={{ width: 20, height: 20 }}
                                                />
                                            </div>
                                            : null
                                    }
                                </CardActionArea>
                            </Grid>
                            <Button
                                variant="contained"
                                style={{
                                    backgroundColor: 'white',
                                    color: '#4851de',
                                    borderRadius: '15px',
                                    height: '40px',
                                    width: '25%',
                                    border: '1px solid #4851de',
                                    marginTop: '18px'
                                }}
                                onClick={handleCloseActionsModal}
                            >
                                Fechar
                            </Button>
                        </Grid>
                    </>
                )
                    :
                    null
            }
            {
                modalPicture && viewLocation == false ?
                    <ViewPicture
                        fotoModal={fotoModal}
                        handleClosePicture={handleClosePicture}
                    /> : null
            }
            {
                viewLocation && modalPicture == false ?
                    <ViewLocation
                        handleCloseViewLocation={handleCloseViewLocation}
                        row={timesheetRow}
                        locationAProved={locationAProved}
                        evetnMap={evetnMap}
                    /> : null
            }
        </Dialog>


    )
}

export default ActionsTimesheet;